import React from "react";

// Uses the real STAND LF logotype (name is already in the image).
export const Logo = ({ light = false, className = "h-11" }) => (
  <img
    src={light ? "/logo-light.png" : "/logo.png"}
    alt="STAND LF"
    className={`${className} w-auto object-contain select-none`}
    draggable={false}
  />
);
